import { styled, Typography } from 'ui';
import { useLayout } from '@context/LayoutContext';

const StyledTypography = styled(Typography)`
  text-transform: capitalize;
`;

export function PageHeaderTitle() {
  const { title } = useLayout();

  if (!title) return null;
  return <StyledTypography variant="h4">{title}</StyledTypography>;
}
